import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cedfa582")

_pushScopeId("data-v-cedfa582")
const _hoisted_1 = { class: "flex flex-col items-center w-full px-1" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center mb-4" }
const _hoisted_3 = { class: "text-base font-bold text-gray-lp-300" }
const _hoisted_4 = { class: "w-full text-xs text-left" }
const _hoisted_5 = { class: "p-3 bg-green-50 border-dashed border-green-lp-200 rounded-t-xl flex items-center justify-between" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = {
  class: "text-xl font-bold text-gray-lp-300 tracking-tight",
  "data-testid": "booking-success-modal-stt-no"
}
const _hoisted_8 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
  })
], -1)
const _hoisted_10 = { class: "border-l border-r border-b border-gray-lp-1400 rounded-b-xl overflow-hidden -mt-[1px]" }
const _hoisted_11 = { class: "grid grid-cols-2 border-b border-gray-lp-1400" }
const _hoisted_12 = { class: "p-3 border-r border-gray-lp-1400" }
const _hoisted_13 = { class: "text-gray-lp-600 mb-0.5" }
const _hoisted_14 = { class: "p-3" }
const _hoisted_15 = { class: "text-gray-lp-600 mb-0.5" }
const _hoisted_16 = { class: "grid grid-cols-2 border-b border-gray-lp-1400" }
const _hoisted_17 = { class: "p-3 border-r border-gray-lp-1400" }
const _hoisted_18 = { class: "text-gray-lp-600 mb-0.5" }
const _hoisted_19 = { class: "font-semibold text-gray-lp-300 uppercase" }
const _hoisted_20 = { class: "p-3" }
const _hoisted_21 = { class: "text-gray-lp-600 mb-0.5" }
const _hoisted_22 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_23 = {
  key: 0,
  class: "px-3 pt-3 flex justify-between items-center bg-gray-lp-1000"
}
const _hoisted_24 = { class: "text-gray-lp-600" }
const _hoisted_25 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_26 = { class: "p-3 bg-gray-lp-1000 flex items-center justify-between" }
const _hoisted_27 = { class: "mb-0.5" }
const _hoisted_28 = { class: "font-semibold" }
const _hoisted_29 = { class: "flex flex-col items-end gap-1" }
const _hoisted_30 = { class: "flex items-center gap-1.5" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs text-gray-lp-600 line-through"
}
const _hoisted_32 = { class: "text-sm font-bold text-gray-lp-300" }
const _hoisted_33 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_34 = {
  key: 0,
  class: "summary-discount-chip"
}
const _hoisted_35 = { class: "summary-discount-chip__text" }
const _hoisted_36 = { class: "flex items-center justify-between gap-3 w-full pt-1" }
const _hoisted_37 = { class: "flex items-center justify-end gap-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, _mergeProps(_ctx.messageEntities, { ref: "modal-ref" }), {
    custom: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("bookingV4.success.title")), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.detailStt.sttNo), 1),
              (_ctx.detailData.isCod || _ctx.detailData.isDfod)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("img", {
                      class: "h-4",
                      src: 
                    require(`@/app/ui/assets/svg/${
                      _ctx.detailData.isDfod ? 'dfod' : 'cod'
                    }-logo-2.svg`)
                  
                    }, null, 8, ["src"])
                  ]))
                : (
                  _ctx.paymentMethodDisplay || _ctx.detailData.paymentMethodLabel
                )
                  ? (_openBlock(), _createBlock("span", {
                      key: 1,
                      class: ["px-2.5 py-0.5 text-xs rounded-full transition-colors", _ctx.paymentBadgeClass],
                      "data-testid": "booking-success-modal-payment-badge"
                    }, _toDisplayString(_ctx.paymentBadgeText), 3))
                  : _createCommentVNode("", true)
            ]),
            _createVNode("button", {
              type: "button",
              class: "flex items-center gap-1 font-semibold text-gray-lp-300 hover:opacity-80 transition-opacity",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCopyStt && _ctx.onCopyStt(...args)))
            }, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.success.copy")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("bookingV4.success.recipient")), 1),
                _createVNode("p", {
                  class: "font-semibold text-gray-lp-300 truncate",
                  title: _ctx.detailData.recipientName
                }, _toDisplayString(_ctx.recipientName), 9, ["title"])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("bookingV4.success.destination")), 1),
                _createVNode("p", {
                  class: "font-semibold text-gray-lp-300 truncate",
                  title: _ctx.detailStt.sttDestinationDistrictName
                }, _toDisplayString(_ctx.detailStt.sttDestinationDistrictName), 9, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("bookingV4.success.serviceType")), 1),
                _createVNode("p", _hoisted_19, _toDisplayString(_ctx.detailStt.productType), 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("bookingV4.success.estimation")), 1),
                _createVNode("p", _hoisted_22, _toDisplayString(_ctx.estimationDate), 1)
              ])
            ]),
            (_ctx.detailData.isCod || _ctx.detailData.isDfod)
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _createVNode("span", _hoisted_24, _toDisplayString(_ctx.detailData.isDfod
                    ? _ctx.$t("bookingV4.success.dfodFee")
                    : _ctx.$t("bookingV4.success.codFee")), 1),
                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.isTariffMasked
                    ? _ctx.formatHidePrice
                    : _ctx.formatPriceCurrency(_ctx.detailData.codFee)), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", null, [
                _createVNode("p", _hoisted_27, _toDisplayString(_ctx.detailData.isCod || _ctx.detailData.isDfod
                      ? _ctx.$t("bookingV4.success.payableByReceiver")
                      : _ctx.$t("bookingV4.success.totalTariff")), 1),
                _createVNode("p", _hoisted_28, _toDisplayString(_ctx.totalPieces || 1) + " " + _toDisplayString(_ctx.$t("bookingV4.success.pieces")) + " • " + _toDisplayString(_ctx.detailStt.chargeableWeight) + " kg ", 1)
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  (_ctx.showOriginalTariff)
                    ? (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(_ctx.isTariffMasked
                        ? _ctx.formatHidePrice
                        : _ctx.formatPriceRP(_ctx.originalTariff)), 1))
                    : _createCommentVNode("", true),
                  _createVNode("span", _hoisted_32, _toDisplayString(_ctx.isPayableByReceiverMasked
                        ? _ctx.formatHidePrice
                        : _ctx.formatPriceCurrency(_ctx.finalTariff)), 1)
                ]),
                (_ctx.hasPromoDiscount)
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      (_ctx.combinedPromoDiscountLabel)
                        ? (_openBlock(), _createBlock("div", _hoisted_34, [
                            _createVNode("span", _hoisted_35, _toDisplayString(_ctx.combinedPromoDiscountLabel), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    "custom-button": _withId(() => [
      _createVNode("div", _hoisted_36, [
        _createVNode(_component_LpButton, {
          title: _ctx.$t('bookingV4.success.close'),
          textColor: "black-lp-300",
          color: "gray-lp-600",
          fontWeight: "semibold",
          outline: "",
          onClick: _ctx.onClose
        }, null, 8, ["title", "onClick"]),
        _createVNode("div", _hoisted_37, [
          (_ctx.showCreateInvoice)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                title: _ctx.$t('bookingV4.success.printInvoice'),
                textColor: "red-lp-100",
                color: "red-lp-100",
                fontWeight: "semibold",
                outline: "",
                onClick: _ctx.onPreviewInvoice
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.receiptFormat !== 'none')
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 1,
                "data-testid": "booking-success-modal-button-print",
                title: _ctx.printButtonTitle,
                textColor: "white",
                color: "red-lp-100",
                onClick: _ctx.onSubmit
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 16))
})